import { useTranslation } from 'react-i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

import { getFamilyList } from '../../organisms-cms/child-bio/utils/familyList';
import { listFormat } from '../../organisms-cms/child-bio/utils/simpleList';
import { getAge } from '../../utils/child-bio';

type ChildBioSummaryBaseProps = {
  details: ChildDetails;
  translatedCountry: string;
  className?: string;
};

type ChildBioSummaryShortProps = ChildBioSummaryBaseProps & {
  short: true;
  translatedLanguage?: never;
};

type ChildBioSummaryLongProps = ChildBioSummaryBaseProps & {
  short?: false | undefined;
  translatedLanguage: string;
};

export type ChildBioSummaryProps =
  | ChildBioSummaryShortProps
  | ChildBioSummaryLongProps;

export const ChildBioSummary = ({
  className = 'mb-comfy-sm',
  details,
  translatedCountry,
  translatedLanguage,
  short = false,
}: ChildBioSummaryProps) => {
  const { t } = useTranslation(['bio']);

  const age = getAge(details.ageInYearsAndMonths);

  const favoriteActivities =
    details.interests.thingsILike.length > 0
      ? t('bio:favoriteActivities', {
          context: details.gender,
          favorites: listFormat(
            short
              ? details.interests.thingsILike.slice(0, 3)
              : details.interests.thingsILike,
          ),
        })
      : '';

  const projectActivities =
    details.interests.favoriteProjectActivity.length > 0
      ? t('bio:projectActivities', {
          context: details.gender,
          activities: listFormat(details.interests.favoriteProjectActivity),
        })
      : '';

  return (
    <div className={className}>
      {t(short ? 'bio:summaryShort' : 'bio:summary', {
        context: details.gender,
        childName: details.name.preferred,
        koreanName: details.hangul.preferred || details.name.preferred,
        age,
        country: translatedCountry,
        family: getFamilyList(details.householdList[0].householdMemberList),
        favoriteActivities,
        projectActivities,
        ...(short ? {} : { language: translatedLanguage }),
      })}
    </div>
  );
};
